module.exports = __webpack_public_path__ + "img/hall-li1.2d65a99a.png";